import request from '@/utils/request'

export function updateCfg(data) {
  return request({
    url: 'api/v1/publish/updateCfg',
    method: 'post',
    data: data
  })
}

export function getCfg(data) {
  return request({
    url: 'api/v1/publish/getCfg',
    method: 'post',
    params: data
  })
}

export function delCfg(data) {
  return request({
    url: 'api/v1/publish/del',
    method: 'delete',
    data: data
  })
}

